module.exports = __webpack_public_path__ + "static/img/bg.0abf839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/文化娱乐/bg.png
// module id = VAne
// module chunks = 1